import {
  Typography,
  Box,
  Grid,
  ListItem,
  List,
  ListItemText,
  ListItemIcon,
} from "@mui/material/";
import HexagonIcon from "@mui/icons-material/Hexagon";
import { Link } from "react-router-dom";

const TermsCondition = () => {
  return (
    <Grid
      container
      display={"flex"}
      justifyContent={"center"}
      paddingX={3}
      paddingTop={3}
    >
      <Grid
        item
        sx={{
          flexGrow: 1,
          alignItems: "center",
        }}
        xs={12}
        md={8}
        lg={5}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "left",
          }}
        >
          <Typography
            component="h1"
            variant="h3"
            gutterBottom
            m={3}
            marginLeft={0}
          >
            Terms and Conditions
          </Typography>
          <Typography variant="body1" paragraph>
            Our Terms and Conditions were last updated on April 2, 2024.
          </Typography>
          <Typography variant="body1" paragraph>
            Please read these Terms and Conditions carefully before using Our
            Service.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            Interpretation and Definitions
          </Typography>
          <Typography component="h3" variant="h5" gutterBottom>
            Interpretation
          </Typography>
          <Typography variant="body1" paragraph>
            The words of which the initial letter is capitalized have meanings
            defined under the following conditions. The following definitions
            shall have the same meaning regardless of whether they appear in
            singular or in plural.
          </Typography>
          <Typography component="h3" variant="h5" gutterBottom>
            Definitions
          </Typography>
          <Typography variant="body1">
            For the purposes of these Terms and Conditions:
            <List>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  “Affiliate” means an entity that controls, is controlled by or
                  is under common control with a party, where "control" means
                  ownership of 50% or more of the shares, equity interest or
                  other securities entitled to vote for election of directors or
                  other managing authority.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  “Account” means a unique account created for You to access our
                  Service or parts of our Service.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  “Company” (referred to as either "the Company", "We", "Us" or
                  "Our" in this Agreement) refers to TVA BE0772.508.196.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>“Country” refers to Belgium.</ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  “Content” refers to content such as text, images, or other
                  information that can be posted, uploaded, linked to or
                  otherwise made available by You, regardless of the form of
                  that content.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  “Device” means any device that can access the Service such as
                  a computer, a cell phone or a digital tablet.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  “Feedback” means feedback, innovations or suggestions sent by
                  You regarding the attributes, performance or features of our
                  Service.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>“Service” refers to the Website.</ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>“Product” refers to the Website.</ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  “Terms and Conditions” (also referred as "Terms") mean these
                  Terms and Conditions that form the entire agreement between
                  You and the Company regarding the use of the Service. This
                  Terms and Conditions Agreement was generated by TermsFeed SaaS
                  Terms and Conditions Generator.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  “Third-party Social Media Service” means any services or
                  content (including data, information, products or services)
                  provided by a third-party that may be displayed, included or
                  made available by the Service.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  “Website” refers to afitpilot.com, accessible from
                  www.afitpilot.com
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  “You” means the individual accessing or using the Service, or
                  the company, or other legal entity on behalf of which such
                  individual is accessing or using the Service, as applicable.
                </ListItemText>
              </ListItem>
            </List>
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (1) Introduction
          </Typography>
          <Typography variant="body1" paragraph>
            These terms of use and purchase govern your use of www.afitpilot.com
            (the “Website”) and your purchase of digital content and services
            offered via the Website; by using the Website, you agree to these
            terms of use in full and they form part of your contract with us to
            provide the Website and related services including any digital
            content and subscription or other services made available on the
            Website (our “Products”) to you. If you disagree with these terms of
            use or any part of these terms of use, please do not register,
            subscribe or use the Website. When we refer to the Website we mean
            www.afitipilot.com and the digital content and services made
            available by us through it.
          </Typography>
          <Typography variant="body1" paragraph>
            Please read – how our Products (which include our Website) are
            intended to be used. We make no claims or representations in
            relation to the emotional, health or commercial benefits of using
            our Products and the information provided on the Website is no
            substitute for professional medical advice where applicable. If you
            are concerned about health issues you are advised to consult your
            doctor. In particular:
            <List>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Our Products are provided for information and entertainment
                  purposes only and not for medical assessment purposes, and for
                  your own personal use (and not e.g. to screen or assess
                  others) and for no other purpose.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Our Products do not provide medical advice.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Our Products should not be regarded as or relied upon as being
                  a comprehensive or accurate opinion or assessment concerning
                  your physical health. We just do not know enough about you to
                  guarantee that. Where you have any concerns arising out of
                  your use of our Products you should seek appropriate
                  professional advice.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Any decisions that you make once you have used or read the
                  content of our Products are for you alone and we will not be
                  liable for the consequences of any such decisions.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Our Products are for personal use only and are not intended
                  for use in any business, educational, employment or
                  recruitment context.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Whilst we provide texts of our Products in languages other
                  than in English the accuracy of such translations is not
                  guaranteed (for example, many translations are contributed by
                  volunteers) and use is at your own risk.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  You must be over the age of 13 years (or above the relevant
                  age of consent in your country) to use the Website and
                  purchase our Products.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  The official text is the English version of the Website. Any
                  discrepancies or differences created in the translation to
                  other languages are not binding and have no legal effect for
                  any purpose. If any questions arise related to the accuracy of
                  the information contained in the non-English versions of the
                  Website, please refer to the English version of the Website
                  which is the official version.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  The Website uses cookies. By using the Website and agreeing to
                  these terms of use, you consent to our use of cookies in
                  accordance with the terms of our Privacy Policy.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Personal data you provide to us will be handled in accordance
                  with our Privacy Policy.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Please note that these Terms and Conditions of Use and
                  Purchase may be amended from time to time to update them to
                  reflect changes in the law or our commercial and business
                  practices. Notification of any changes will be made by posting
                  new terms onto the Website. In continuing to use the Website
                  you confirm that you accept the then current terms and
                  conditions in full at the time you use the Website.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  If you object to any change you have the right to cancel your
                  use of the Website and the ongoing provision of Products from
                  us within 30 days of the change by contacting us at{" "}
                  <Link
                    to=""
                    onClick={() => {
                      window.location.href = "mailto:info.afitpilot@gmail.com";
                    }}
                  >
                    info.afitpilot@gmail.com
                  </Link>
                  .
                </ListItemText>
              </ListItem>
            </List>
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (2) User Accounts
          </Typography>
          <Typography variant="body1" paragraph>
            When You create an account with Us, You must provide Us information
            that is accurate, complete, and current at all times. Failure to do
            so constitutes a breach of the Terms, which may result in immediate
            termination of Your account on Our Service.
          </Typography>
          <Typography variant="body1" paragraph>
            You are responsible for safeguarding the password that You use to
            access the Service and for any activities or actions under Your
            password, whether Your password is with Our Service or a Third-Party
            Social Media Service.
          </Typography>
          <Typography variant="body1" paragraph>
            You agree not to disclose Your password to any third party. You must
            notify Us immediately upon becoming aware of any breach of security
            or unauthorized use of Your account. If you know or suspect that
            someone else knows your password you should notify us by contacting{" "}
            <Link
              to=""
              onClick={() => {
                window.location.href = "mailto:info.afitpilot@gmail.com";
              }}
            >
              info.afitpilot@gmail.com
            </Link>{" "}
            immediately.
          </Typography>
          <Typography variant="body1" paragraph>
            You may not use as a username the name of another person or entity
            or that is not lawfully available for use, a name or trademark that
            is subject to any rights of another person or entity other than You
            without appropriate authorization, or a name that is otherwise
            offensive, vulgar or obscene.
          </Typography>
          <Typography variant="body1" paragraph>
            You agree that all personal information that you supply to us will
            be accurate, complete and kept up to date at all times. We may use
            the information provided to us to contact you in accordance with our
            Privacy Policy.
          </Typography>
          <Typography variant="body1" paragraph>
            You may not have more than one registration with the Website. We
            reserve the right at our discretion to delete or cancel the
            registration of any person who in our opinion possesses more than
            one profile at any time.
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to suspend or cancel any registration at any
            time where it is reasonable for us to do so, including where you are
            not in compliance with these Terms and Conditions of Use and
            Purchase.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (3) Somatotype Test
          </Typography>
          <Typography variant="body1" paragraph>
            You will be able to use the Website to take a free somatotype test
            (the “Somatotype Test”).
          </Typography>
          <Typography variant="body1" paragraph>
            The results of the Somatotype Test are automatically analyzed and
            you will receive a result which will assign to you one of thirteen
            different somatotypes, along with a description of the traits of the
            particular somatotype (the “Test Result”). We may also record and
            use your answers and results for research purposes in accordance
            with our Privacy Policy.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (4) License to Use Website/Products
          </Typography>
          <Typography variant="body1" paragraph>
            Unless otherwise stated, we or our licensors, own the intellectual
            property rights in the Website and material on the Website,
            including all Products, including but not limited to copyright and
            associated moral rights, trade marks, get-up, and unregistered
            rights, goodwill, know-how, software, database rights, and all other
            intellectual property rights. Subject to the license below, all
            these intellectual property rights are exclusively reserved. Where
            the Products feature the intellectual property of third parties
            which we do not own this is clearly stated.
          </Typography>
          <Typography variant="body1" paragraph>
            You may view, download for caching purposes only, and print pages
            from the Website or any Products for your own personal use, subject
            to the restrictions set out below and elsewhere in these terms of
            use.
          </Typography>
          <Typography variant="body1" paragraph>
            Without prior consent from us you must not:
            <List>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  reproduce, translate or reverse engineer material from this
                  Website (including republication on another Website or other
                  reproduction or communication of our Products without
                  consent);
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  sell, rent or sub-license material or Products from the
                  Website;
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  communicate any material from the Website or Products to the
                  public;
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  reproduce, duplicate, copy or otherwise exploit material on
                  our Website or Products for a commercial purpose;{" "}
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  edit or otherwise modify any material on the Website or
                  Products;
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  redistribute material from this Website or Products except for
                  content specifically and expressly made available for
                  redistribution; or
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  reproduce any intellectual property rights of third parties on
                  our Website without the consent of those parties.
                </ListItemText>
              </ListItem>
            </List>
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (5) Content
          </Typography>
          <Typography component="h3" variant="h5" gutterBottom>
            Your Right to Post Content
          </Typography>
          <Typography variant="body1" paragraph>
            Our Service allows You to post Content. You are responsible for the
            Content that You post to the Service, including its legality,
            reliability, and appropriateness.
          </Typography>
          <Typography variant="body1" paragraph>
            By posting Content to the Service, You grant Us the right and
            license to use, modify, publicly perform, publicly display,
            reproduce, and distribute such Content on and through the Service.
            You retain any and all of Your rights to any Content You submit,
            post or display on or through the Service and You are responsible
            for protecting those rights. You agree that this license includes
            the right for Us to make Your Content available to other users of
            the Service, who may also use Your Content subject to these Terms.
          </Typography>
          <Typography variant="body1" paragraph>
            You represent and warrant that: (i) the Content is Yours (You own
            it) or You have the right to use it and grant Us the rights and
            license as provided in these Terms, and (ii) the posting of Your
            Content on or through the Service does not violate the privacy
            rights, publicity rights, copyrights, contract rights or any other
            rights of any person.
          </Typography>
          <Typography component="h3" variant="h5" gutterBottom>
            Content Restrictions
          </Typography>
          <Typography variant="body1" paragraph>
            The Company is not responsible for the content of the Service's
            users. You expressly understand and agree that You are solely
            responsible for the Content and for all activity that occurs under
            your account, whether done so by You or any third person using Your
            account.
          </Typography>
          <Typography variant="body1" paragraph>
            You may not transmit any Content that is unlawful, offensive,
            upsetting, intended to disgust, threatening, libelous, defamatory,
            obscene or otherwise objectionable. Examples of such objectionable
            Content include, but are not limited to, the following:
            <List>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Unlawful or promoting unlawful activity.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Defamatory, discriminatory, or mean-spirited content,
                  including references or commentary about religion, race,
                  sexual orientation, gender, national/ethnic origin, or other
                  targeted groups.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Spam, machine, or randomly generated, constituting
                  unauthorized or unsolicited advertising, chain letters, any
                  other form of unauthorized solicitation, or any form of
                  lottery or gambling.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Containing or installing any viruses, worms, malware, trojan
                  horses, or other content that is designed or intended to
                  disrupt, damage, or limit the functioning of any software,
                  hardware or telecommunications equipment or to damage or
                  obtain unauthorized access to any data or other information of
                  a third person.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Infringing on any proprietary rights of any party, including
                  patent, trademark, trade secret, copyright, right of publicity
                  or other rights.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Impersonating any person or entity including the Company and
                  its employees or representatives.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Violating the privacy of any third person.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>False information and features.</ListItemText>
              </ListItem>
            </List>
          </Typography>
          <Typography variant="body1" paragraph>
            The Company reserves the right, but not the obligation, to, in its
            sole discretion, determine whether or not any Content is appropriate
            and complies with this Terms, refuse or remove this Content. The
            Company further reserves the right to make formatting and edits and
            change the manner of any Content. The Company can also limit or
            revoke the use of the Service if You post such objectionable
            Content. As the Company cannot control all content posted by users
            and/or third parties on the Service, you agree to use the Service at
            your own risk. You understand that by using the Service You may be
            exposed to content that You may find offensive, indecent, incorrect
            or objectionable, and You agree that under no circumstances will the
            Company be liable in any way for any content, including any errors
            or omissions in any content, or any loss or damage of any kind
            incurred as a result of your use of any content.
          </Typography>
          <Typography component="h3" variant="h5" gutterBottom>
            Content Backups
          </Typography>
          <Typography variant="body1" paragraph>
            Although regular backups of Content are performed, the Company does
            not guarantee there will be no loss or corruption of data.
          </Typography>
          <Typography variant="body1" paragraph>
            Corrupt or invalid backup points may be caused by, without
            limitation, Content that is corrupted prior to being backed up or
            that changes during the time a backup is performed.
          </Typography>
          <Typography variant="body1" paragraph>
            The Company will provide support and attempt to troubleshoot any
            known or discovered issues that may affect the backups of Content.
            But You acknowledge that the Company has no liability related to the
            integrity of Content or the failure to successfully restore Content
            to a usable state.
          </Typography>
          <Typography variant="body1" paragraph>
            You agree to maintain a complete and accurate copy of any Content in
            a location independent of the Service.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (6) Copyright Policy
          </Typography>
          <Typography component="h3" variant="h5" gutterBottom>
            Intellectual Property Infringement
          </Typography>
          <Typography variant="body1" paragraph>
            We respect the intellectual property rights of others. It is Our
            policy to respond to any claim that Content posted on the Service
            infringes a copyright or other intellectual property infringement of
            any person.
          </Typography>
          <Typography variant="body1" paragraph>
            You may be held accountable for damages (including costs and
            attorneys' fees) for misrepresenting that any Content is infringing
            Your copyright.
          </Typography>
          <Typography component="h3" variant="h5" gutterBottom>
            Copyright Infringement Claims
          </Typography>
          <Typography variant="body1" paragraph>
            You may submit a notification pursuant to us with the following
            information in writing:
            <List>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  An electronic or physical signature of the person authorized
                  to act on behalf of the owner of the copyright's interest.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  A description of the copyrighted work that You claim has been
                  infringed, including the URL (i.e., web page address) of the
                  location where the copyrighted work exists or a copy of the
                  copyrighted work.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Identification of the URL or other specific location on the
                  Service where the material that You claim is infringing is
                  located.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Containing or installing any viruses, worms, malware, trojan
                  horses, or other content that is designed or intended to
                  disrupt, damage, or limit the functioning of any software,
                  hardware or telecommunications equipment or to damage or
                  obtain unauthorized access to any data or other information of
                  a third person.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  Your address, telephone number, and email address.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  A statement by You that You have a good faith belief that the
                  disputed use is not authorized by the copyright owner, its
                  agent, or the law.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  A statement by You, made under penalty of perjury, that the
                  above information in Your notice is accurate and that You are
                  the copyright owner or authorized to act on the copyright
                  owner's behalf.
                </ListItemText>
              </ListItem>
            </List>
          </Typography>
          <Typography variant="body1" paragraph>
            You can contact us via email (
            <Link
              to=""
              onClick={() => {
                window.location.href = "mailto:info.afitpilot@gmail.com";
              }}
            >
              info.afitpilot@gmail.com
            </Link>
            ). Upon receipt of a notification, the Company will take whatever
            action, in its sole discretion, it deems appropriate, including
            removal of the challenged content from the Service.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (7) Intellectual Property
          </Typography>
          <Typography variant="body1" paragraph>
            The Service and its original content (excluding Content provided by
            You or other users), features and functionality are and will remain
            the exclusive property of the Company and its licensors.
          </Typography>
          <Typography variant="body1" paragraph>
            The Service is protected by copyright, trademark, and other laws of
            both the Country and foreign countries.
          </Typography>
          <Typography variant="body1" paragraph>
            Our trademarks and trade dress may not be used in connection with
            any product or service without the prior written consent of the
            Company.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (8) Your Feedback to Us
          </Typography>
          <Typography variant="body1" paragraph>
            You assign all rights, title and interest in any Feedback You
            provide the Company. If for any reason such assignment is
            ineffective, You agree to grant the Company a non-exclusive,
            perpetual, irrevocable, royalty free, worldwide right and license to
            use, reproduce, disclose, sub-license, distribute, modify and
            exploit such Feedback without restriction.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (9) Unsolicited Idea Submissions
          </Typography>
          <Typography variant="body1" paragraph>
            We do not accept or consider unsolicited ideas, including but not
            limited to creative proposals, ideas for new, enhanced or improved
            products, technologies or services, marketing campaigns, promotions,
            processes, materials, artwork, plans, strategies, theories or
            product names. Please do not submit any unsolicited ideas, articles,
            original creative artwork, suggestions or other works in any form to
            us.
            <List>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  The sole purpose of this section is to simply avoid potential
                  disputes when our products, website content or business
                  strategies might seem similar to unsolicited ideas submitted
                  to us. If, despite our request that you not send us any ideas
                  or suggestions, you still choose to submit them, then
                  regardless of what your letter, comment, e-mail or any other
                  form of communication says, you agree and understand that the
                  following terms will apply to your submissions:
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  A description of the copyrighted work that You claim has been
                  infringed, including the URL (i.e., web page address) of the
                  location where the copyrighted work exists or a copy of the
                  copyrighted work.
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  your submissions will automatically become our sole property,
                  without any compensation to you, and we will have no
                  obligation of any kind to you or anyone else with respect to
                  your submissions;
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  we will be free to use or redistribute the submissions in any
                  way and for any purpose, including but not limited to
                  developing, acquiring or advertising products or services
                  competitive with those mentioned by you;
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  there will be no obligation for us to review your submissions
                  or develop your ideas;
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  no confidential relationship or obligation of secrecy will be
                  created between you and us by your submission and its
                  consideration by us – everything you submit shall be deemed to
                  be non-confidential and non-proprietary. We shall be free to
                  use any information you submit on an unrestricted basis,
                  whether or not we were working on similar ideas, products or
                  technology prior to receiving your submission.
                </ListItemText>
              </ListItem>
            </List>
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (10) Links to Other Websites
          </Typography>
          <Typography variant="body1" paragraph>
            Our Service may contain links to third-party web sites or services
            that are not owned or controlled by the Company.
          </Typography>
          <Typography variant="body1" paragraph>
            The Company has no control over, and assumes no responsibility for,
            the content, privacy policies, or practices of any third party web
            sites or services. You further acknowledge and agree that the
            Company shall not be responsible or liable, directly or indirectly,
            for any damage or loss caused or alleged to be caused by or in
            connection with the use of or reliance on any such content, goods or
            services available on or through any such web sites or services.
          </Typography>
          <Typography variant="body1" paragraph>
            We strongly advise You to read the terms and conditions and privacy
            policies of any third-party web sites or services that You visit.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (11) Termination
          </Typography>
          <Typography variant="body1" paragraph>
            We may terminate or suspend Your Account immediately, without prior
            notice or liability, for any reason whatsoever, including without
            limitation if You breach these Terms and Conditions.
          </Typography>
          <Typography variant="body1" paragraph>
            Upon termination, Your right to use the Service will cease
            immediately. If You wish to terminate Your Account, You may simply
            discontinue using the Service.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (12) Limitation of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            Notwithstanding any damages that You might incur, the entire
            liability of the Company and any of its suppliers under any
            provision of this Terms and Your exclusive remedy for all of the
            foregoing shall be limited to the amount actually paid by You
            through the Service.
          </Typography>
          <Typography variant="body1" paragraph>
            To the maximum extent permitted by applicable law, in no event shall
            the Company or its suppliers be liable for any special, incidental,
            indirect, or consequential damages whatsoever (including, but not
            limited to, damages for loss of profits, loss of data or other
            information, for business interruption, for personal injury, loss of
            privacy arising out of or in any way related to the use of or
            inability to use the Service, third-party software and/or
            third-party hardware used with the Service, or otherwise in
            connection with any provision of this Terms), even if the Company or
            any supplier has been advised of the possibility of such damages and
            even if the remedy fails of its essential purpose.
          </Typography>
          <Typography variant="body1" paragraph>
            Some states do not allow the exclusion of implied warranties or
            limitation of liability for incidental or consequential damages,
            which means that some of the above limitations may not apply. In
            these states, each party's liability will be limited to the greatest
            extent permitted by law.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (13) "AS IS" and "AS AVAILABLE" Disclaimer
          </Typography>
          <Typography variant="body1" paragraph>
            The Service is provided to You "AS IS" and "AS AVAILABLE" and with
            all faults and defects without warranty of any kind. To the maximum
            extent permitted under applicable law, the Company, on its own
            behalf and on behalf of its Affiliates and its and their respective
            licensors and service providers, expressly disclaims all warranties,
            whether express, implied, statutory or otherwise, with respect to
            the Service, including all implied warranties of merchantability,
            fitness for a particular purpose, title and non-infringement, and
            warranties that may arise out of course of dealing, course of
            performance, usage or trade practice. Without limitation to the
            foregoing, the Company provides no warranty or undertaking, and
            makes no representation of any kind that the Service will meet Your
            requirements, achieve any intended results, be compatible or work
            with any other software, applications, systems or services, operate
            without interruption, meet any performance or reliability standards
            or be error free or that any errors or defects can or will be
            corrected.
          </Typography>
          <Typography variant="body1" paragraph>
            Without limiting the foregoing, neither the Company nor any of the
            company's provider makes any representation or warranty of any kind,
            express or implied: (i) as to the operation or availability of the
            Service, or the information, content, and materials or products
            included thereon; (ii) that the Service will be uninterrupted or
            error-free; (iii) as to the accuracy, reliability, or currency of
            any information or content provided through the Service; or (iv)
            that the Service, its servers, the content, or e-mails sent from or
            on behalf of the Company are free of viruses, scripts, trojan
            horses, worms, malware, timebombs or other harmful components.
          </Typography>
          <Typography variant="body1" paragraph>
            Some jurisdictions do not allow the exclusion of certain types of
            warranties or limitations on applicable statutory rights of a
            consumer, so some or all of the above exclusions and limitations may
            not apply to You. But in such a case the exclusions and limitations
            set forth in this section shall be applied to the greatest extent
            enforceable under applicable law.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (14) Governing Law
          </Typography>
          <Typography variant="body1" paragraph>
            The laws of the Country, excluding its conflicts of law rules, shall
            govern this Terms and Your use of the Service. Your use of the
            Application may also be subject to other local, state, national, or
            international laws.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (15) Disputes Resolution
          </Typography>
          <Typography variant="body1" paragraph>
            If You have any concern or dispute about the Service, You agree to
            first try to resolve the dispute informally by contacting the
            Company.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (16) For European Union (EU) Users
          </Typography>
          <Typography variant="body1" paragraph>
            If You are a European Union consumer, you will benefit from any
            mandatory provisions of the law of the country in which you are
            resident in.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (17) Delay in Enforcing this Contract
          </Typography>
          <Typography variant="body1" paragraph>
            Even if we delay in enforcing this contract, we can still enforce it
            later. If we do not insist immediately that you do anything you are
            required to do under these terms, or if we delay in taking steps
            against you in respect of your breaking this contract, that will not
            mean that you do not have to do those things and it will not prevent
            us taking steps against you at a later date. For example, if you
            miss a payment and we do not chase you but we continue to provide
            the Products, we can still require you to make the payment at a
            later date.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (18) Severability and Waiver
          </Typography>
          <Typography component="h3" variant="h5" gutterBottom>
            Severability
          </Typography>
          <Typography variant="body1" paragraph>
            If any provision of these Terms is held to be unenforceable or
            invalid, such provision will be changed and interpreted to
            accomplish the objectives of such provision to the greatest extent
            possible under applicable law and the remaining provisions will
            continue in full force and effect.
          </Typography>
          <Typography component="h3" variant="h5" gutterBottom>
            Waiver
          </Typography>
          <Typography variant="body1" paragraph>
            Except as provided herein, the failure to exercise a right or to
            require performance of an obligation under these Terms shall not
            effect a party's ability to exercise such right or require such
            performance at any time thereafter nor shall the waiver of a breach
            constitute a waiver of any subsequent breach.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (19) Changes to These Terms and Conditions
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right, at Our sole discretion, to modify or replace
            these Terms at any time. If a revision is material We will make
            reasonable efforts to provide at least 30 days' notice prior to any
            new terms taking effect. What constitutes a material change will be
            determined at Our sole discretion.
          </Typography>
          <Typography variant="body1" paragraph>
            By continuing to access or use Our Service after those revisions
            become effective, You agree to be bound by the revised terms. If You
            do not agree to the new terms, in whole or in part, please stop
            using the website and the Service.
          </Typography>
          <Typography component="h2" variant="h4" gutterBottom>
            (20) Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about these Terms and Conditions, You can
            contact us:
            <List>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  By visiting this page on our website: <br />
                  <Link to="/contact/">https://www.afitpilot.com/contact/</Link>
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <HexagonIcon />
                </ListItemIcon>
                <ListItemText>
                  By sending us an email: <br />
                  <Link
                    to=""
                    onClick={() => {
                      window.location.href = "mailto:info.afitpilot@gmail.com";
                    }}
                  >
                    info.afitpilot@gmail.com
                  </Link>
                </ListItemText>
              </ListItem>
            </List>
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default TermsCondition;
